import {useEffect, useState} from "react";
import CombatSetupPanel from "@/tabletop/encounter/CombatSetupPanel.tsx";
import {useEncounter} from "@/encounter/EncounterHooks.ts";
import {useActiveEncounter} from "@/encounter/ActiveEncounterHooks.ts";
import GameMasterMap from "@/tabletop/dungeon/GameMasterMap.tsx";
import FloatingCombatantPropertiesPanel from "@/tabletop/FloatingCombatantPropertiesPanel.tsx";
import TableTopToolbar from "@/tabletop/TableTopToolbar.tsx";
import {PlayerDisplayBanner} from "@/tabletop/player/PlayerDisplayControls.tsx";
import {TableTopOverlayBoundsProvider} from "@/tabletop/TableTopOverlayBounds.tsx";
import {useTableTopSelection} from "@/tabletop/selection/TableTopSelectionHooks.ts";
import {useTurn} from "@/encounter/turns/TurnHooks.ts";

function ActiveEncounterSync() {
    const encounter = useEncounter();
    const {setActiveEncounter} = useActiveEncounter();
    useEffect(() => setActiveEncounter(encounter), [encounter, setActiveEncounter]);
    return null;
}

export default function GameMasterTableTop() {
    const [combatOpen, setCombatOpen] = useState(false);
    const encounter = useEncounter();
    const {selectedCombatants} = useTableTopSelection();
    const {combatState, runCombatCommand, initialLoading} = useTurn();
    const [takingSelection, setTakingSelection] = useState(false);
    const openCombat = async () => {
        if (takingSelection) {setCombatOpen(true); return;}
        setCombatOpen(true);
        if (initialLoading || combatState.phase === "ACTIVE") return;
        const existing = combatState.participants.map(entry => ({combatantId: entry.combatantId, surprised: entry.surprised}));
        const additions = selectedCombatants.filter(actor => !existing.some(entry => entry.combatantId === actor.id))
            .map(actor => ({combatantId: actor.id, surprised: false}));
        if (!additions.length) return;
        setTakingSelection(true);
        try {
            await runCombatCommand({action: combatState.phase === "IDLE" ? "BEGIN_PREPARATION" : "SET_PARTICIPANTS",
                participants: [...existing, ...additions]});
        } catch { /* The turn provider reports the failure; selection can be retried in the panel. */ }
        finally {setTakingSelection(false);}
    };

    return <>
        <ActiveEncounterSync/>
        <title>Spielleiterkarte | DireDawn</title>
        <TableTopOverlayBoundsProvider>
            <GameMasterMap/>
            <PlayerDisplayBanner/>
            <FloatingCombatantPropertiesPanel/>
            <CombatSetupPanel key={encounter.id} open={combatOpen} takingSelection={takingSelection} onClose={() => setCombatOpen(false)}/>
            <TableTopToolbar onOpenCombat={() => void openCombat()}/>
        </TableTopOverlayBoundsProvider>
    </>;
}
